import React from 'react';
import { H1, P } from './Styles';

const PageNotFound = () => {
    return (
        <div>
            <H1>404</H1>
            <P>Page Not Found!</P>
        </div>
    );
};

export default PageNotFound;
